import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { matchPath, useLocation } from 'react-router-dom';
import { Route } from 'app/enums';
import { MATCH_ID_QUERY_KEY, TOURNAMENT_ID_QUERY_KEY } from 'app/constants';
import { currentMatchSelector } from 'modules/matches/store/current-match/selectors';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';

const DEFAULT_TITLE = 'Cash Matches & Tournaments | OkLetsPlay';

export const useAppTitle = () => {
  const { pathname, search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);

  const tournament = useSelector(currentTournamentSelector.tournament);

  const match = useSelector(currentMatchSelector.match);
  const owner = useSelector(currentMatchSelector.owner);

  const title = useMemo(() => {
    switch (true) {
      case Boolean(matchPath(Route.TournamentOverview, pathname)):
      case Boolean(matchPath(Route.TournamentBracket, pathname)):
      case Boolean(matchPath(Route.TournamentBracketFullScreen, pathname)):
      case Boolean(matchPath(Route.TournamentTeams, pathname)):
      case Boolean(matchPath(Route.TournamentAdmin, pathname)):
      case Boolean(matchPath(Route.TournamentPrizes, pathname)):
      case Boolean(params.get(TOURNAMENT_ID_QUERY_KEY)):
      case Boolean(matchPath(Route.TournamentMyTeam, pathname)): {
        if (!tournament?.name) {
          return DEFAULT_TITLE;
        }

        return `${tournament?.name} - Tournament | OkLetsPlay`;
      }
      case Boolean(params.get(MATCH_ID_QUERY_KEY)): {
        if (!match.game?.title || !owner?.user?.userName) {
          return DEFAULT_TITLE;
        }

        return `1v1 ${match.game?.title} by ${owner?.user?.userName} - Match | OkLetsPlay`;
      }
      default:
        return DEFAULT_TITLE;
    }
  }, [pathname, params, tournament, match, owner]);

  return { title };
};
